// File: MSMERegistration.jsx
import React from "react";

export default function MSMERegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            MSME Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in MSME Registration to avail government benefits, subsidies, and statutory recognition.
          </p>
          <p className="text-gray-700">
            Complete registration process including Udyam portal filing, enterprise classification, credit guarantee eligibility, priority lending access, and government scheme integration for MSMEs across India.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: MSME registration India business) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="MSME Registration India business compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless MSME Udyam Registration approvals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of proprietor/partner/director</li>
                <li>Aadhaar card of authorized signatory</li>
                <li>Business details and GSTIN (if applicable)</li>
                <li>Bank account details with cancelled cheque</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              MSME registration expertise ensuring access to government schemes, priority lending, and statutory benefits through Udyam portal compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Registration Process
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Udyam portal submission with correct enterprise classification (micro/small/medium), NIC code selection, investment/turnover verification, and immediate Udyam certificate generation with QR code validation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Fast Processing & Benefits Access
                </h3>
                <p className="text-gray-700 text-sm">
                  Instant registration completion (within 24 hours), eligibility verification for Credit Guarantee Fund Trust (CGTMSE), priority sector lending, government tender preferences, and MSME Samadhaan portal access for delayed payments.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Comprehensive Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service MSME support including annual turnover updates, enterprise upgradation/downgradation, multiple registrations per PAN, scheme application assistance (PMEGP, ZED, ASPIRE), and ongoing compliance advisory for sustained benefits.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
